import React from "react";
import { Dialog } from "@headlessui/react";
import { IKImage } from "imagekitio-react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./index.css";

const NonEligibleModal = ({ isModalEnabled, setIsModalEnabled }) => {
  const navigate = useNavigate();
  const user_name = useSelector((store) => store?.profileDetails?.name);
  const last_content_played = useSelector(
    (store) => store?.userActivity?.user_last_content_played,
  );
  function getRandomArbitary() {
    const d = new Date();
    let day = d.getDay();

    if (day === 0) return 1;
    else return 8 - day;
  }
  return (
    <Dialog
      open={isModalEnabled}
      onClose={() => setIsModalEnabled(!isModalEnabled)}
      as="div"
      className="fixed inset-0 z-10 flex flex-col  items-center justify-center overflow-y-auto"
    >
      <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
      <Dialog.Title />
      <Dialog.Description />
      <div className="z-10 flex w-4/5 flex-col items-center justify-center rounded-2xl bg-white px-4 py-3 shadow-2xl md:w-2/5  lg:w-[375px]">
        <img
          urlEndpoint="https://img.learntube.ai/public-assets/"
          src={
            "https://img.learntube.ai/public-assets/PRICING/imagez.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1662545344730"
          }
          transformation={[
            {
              height: "100",
              width: "100",
            },
          ]}
          className=" h-[122px] w-[136px] self-start "
        />
        <div className="self-start  text-2xl font-bold">
          Oops, Looks like you are not ready yet.
        </div>
        <div className="mt-2 text-sm ">
          {user_name?.split(" ")?.[0]}, you need to learn more. Why don’t you
          take up the other Pro plans, complete at least{" "}
          <span className="font-bold">1-2 </span>
          micro-skills and then try again. The faster you do it, the more your
          chances.
        </div>
        <div className="mt-2 self-start text-sm">
          Current Seats Left:
          <span className="font-bold text-red-600">{getRandomArbitary()}</span>
        </div>
        <div className="mt-5 w-full">
          <button
            className="modalbutton-background  w-full rounded-3xl px-2  py-2 text-sm text-white"
            onClick={(event) => setIsModalEnabled(false)}
          >
            Explore Other Plans
          </button>
          <button
            className="mt-2 w-full rounded-3xl border-2 border-pricing_blue px-2 py-2 text-sm font-medium text-pricing_blue"
            onClick={(event) => {
              if (last_content_played) {
                navigate(last_content_played);
              } else {
                navigate("/courses");
              }
            }}
          >
            Continue Learning
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default NonEligibleModal;
